import { forwardRef } from 'react';
import { usePdfPageParams } from './hooks/usePdfPageParams';
import { PdfReportFooterProps } from './PdfReportFooter.props';
import { BlueLine, DisclaimerText, FooterContainer, FooterContent, PageNumber } from './PdfReportFooter.styles';

const PdfReportFooter = forwardRef<HTMLDivElement, PdfReportFooterProps>((props, ref) => {
  const { currentPage, totalPages } = usePdfPageParams();
  
  const {
    reportOnly,
    'data-ref': dataRef
  } = props;

  return (
    <FooterContainer ref={ref} reportOnly={reportOnly} data-ref={dataRef}>
      <FooterContent>
        <BlueLine />
        <DisclaimerText>For Discussion Purposes Only - Subject to Change</DisclaimerText>
        <PageNumber>Page {currentPage} of {totalPages}</PageNumber>
      </FooterContent>
    </FooterContainer>
  );
});

PdfReportFooter.displayName = 'PdfReportFooter';

export default PdfReportFooter;
